/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Schema({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M2 1.4a.6.6 0 0 0 0 1.2h8a.6.6 0 1 0 0-1.2zM2 13.4a.6.6 0 1 0 0 1.2h7a.6.6 0 1 0 0-1.2zM4.4 10a.6.6 0 0 1 .6-.6h9a.6.6 0 1 1 0 1.2H5a.6.6 0 0 1-.6-.6M5 5.4a.6.6 0 0 0 0 1.2h9a.6.6 0 1 0 0-1.2z" /></svg>;
}
;